import '@firebase/auth-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ../firebase_sdk-20260526/packages/firebase/compat/auth/dist/index.esm.js
// module id = oaAX
// module chunks = 18